/**
 * Force a real file download from a Blob using a temporary anchor element.
 *
 * Unlike `window.open(url)`, this is NOT treated as a popup by browsers, so it
 * keeps working even when called after an `await` (i.e. outside the original
 * user-gesture tick). This avoids the popup blocker on mobile Safari, Firefox
 * and in-app browsers (Instagram, Gmail, …).
 */
export function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
